// import { Button } from "reactstrap";
import { version } from "./config";
// import { Google } from "@mui/icons-material";

// https://fontawesome.com/icons?d=gallery&s=brands,solid&m=free

export const dashboardRoutes = {
  name: "Dashboard",
  controlID: "liDashboard",
  to: process.env.PUBLIC_URL + "/admin/dashboard",
  exact: true,
  icon: ["fab", "trello"],
  //icon: ['far', 'coffee']
};

export const partnersRoutes = {
  name: "Partners",
  controlID: "liPartner",
  to: process.env.PUBLIC_URL + "/admin/partners",
  icon: "users",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/partners/partner-list",
      name: "Partner List",
      controlID: "liPartnersList",
    },
    // { to: '/admin/partners/partner-details', name: 'Partner Details' }
  ],
};

export const analyticsRoutes = {
  name: "Analytics",
  controlID: "liAnalytics",
  to: process.env.PUBLIC_URL + "/admin/analytics",
  icon: "chart-pie",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/analytics/api-requests-response",
      name: "API Request & Response",
      controlID: "liApiRequestAndResponse",
    },
    // { to: process.env.PUBLIC_URL + "/admin/analytics/reports", name: "Reports", controlID: "liReport" },
    // { to: process.env.PUBLIC_URL + "admin/analytics/api-logs", name: "API Logs", controlID: "liApiLogs" },
  ],
};

export const documentationRoutes = {
  name: "Documentation",
  controlID: "liDocumentation",
  to: process.env.PUBLIC_URL + "/admin/documentation",
  icon: "book",
  linkIcon: "faUpRightFromSquare",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/documentation/api-documentation",
      name: "API Documentation",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/documentation/api-documentation",
      name: "Writeback APIs",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/documentation/pmses-supported",
      name: "PMSes Supported",
      controlID: "liPmsSupported",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/documentation/data-visualization",
      name: "Data Visualization",
      controlID: "liDataVisualization",
    },
    {
      to: process.env.PUBLIC_URL + "/user/documentation/api-documentation",
      name: "Practice Onboarding",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/documentation/apidocs",
      name: "Api Docs",
      controlID: "liapidocs",
    },
  ],
};

export const webhookRoutes = {
  name: "Webhook",
  controlID: "liWebhook",
  to: process.env.PUBLIC_URL + "/admin/webhook",
  icon: "poll",
  exact: true,
};

export const apiExplorerRoutes = {
  name: "API Explorer",
  controlID: "liApiRequestAndResponse",
  to: process.env.PUBLIC_URL + "/admin/api-explorer",
  exact: true,
  icon: "copy",
};

export const errorCodesRoutes = {
  name: "Error Codes",
  controlID: "liErrorCodes",
  to: process.env.PUBLIC_URL + "/admin/error-codes",
  exact: true,
  icon: "triangle-exclamation",
};

export const apiDiagnosticsRoutes = {
  name: "API Diagnostics",
  controlID: "liApiDiagnostics",
  to: process.env.PUBLIC_URL + "/admin/api-diagnostics",
  icon: "chart-column",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/api-diagnostics/api-status",
      name: "API Status",
      controlID: "liApiStatus",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/api-diagnostics/api-logs",
      name: "API Logs",
      controlID: "liApiLogs",
    },
  ],
};

export const settingsRoutes = {
  name: "Settings",
  controlID: "liSettings",
  to: process.env.PUBLIC_URL + "/admin/settings",
  icon: "code-branch",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/settings/profile",
      name: "Profile",
      controlID: "liSecurityAuthentication",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/ghlconfiguration",
      name: "GoHighLevel Configuration",
      controlID: "liGHLConfiguration",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/users",
      name: "Users",
      controlID: "liUserSettings",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/roles",
      name: "Roles",
      controlID: "liRolesSetting",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/table-editor",
      name: "Table Editor",
      controlID: "liTableEditorSettings",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/api-tiers",
      name: "API Tiers",
      controlID: "liAPITiersSettings",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/api-plan",
      name: "API Plans",
      controlID: "liApiPlanSettings",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/announcement",
      name: "Announcement",
      controlID: "liAnnouncementSettings",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/settings/writebackchange",
      name: "Custom Writeback",
      controlID: "liCustomWriteback",
    }
  ],
};

export const billingRoutes = {
  name: "Billing",
  controlID: "liBilling",
  to: process.env.PUBLIC_URL + "/admin/billing",
  icon: "cart-plus",
  exact: true,
  // children: [
  //   { to: "/admin/billing/partner-billing", name: "Partner Billing" },
  //   { to: "/admin/billing/bill", name: "Bill" },
  //   { to: "/admin/billing/dashboard", name: "Dashboard" },
  //   { to: "/admin/billing/reports", name: "Reports" },
  // ],
};

export const supportRoutes = {
  name: "Support",
  to: process.env.PUBLIC_URL + "/admin/writeback",
  icon: "circle-info",
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/support/writeback",
      name: "Writeback",
    },
    // {
    //   to: process.env.PUBLIC_URL + "/admin/support/customerhealthcheck",
    //   name: "Customer Health Check",
    //   controlID: "licustomerhealthcheck",
    // },
    // { to: process.env.PUBLIC_URL + "/admin/support/freshdesk", name: "Tickets", controlID: "liFreshDeskTickets" },
    {
      to: process.env.PUBLIC_URL + "/admin/support/alerts",
      name: "Alerts",
      controlID: "liAlerts",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/support/missedwebhooks",
      name: "Missed Webhooks",
      controlID: "liMissedWebhooks",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/support/singlestore",
      name: "Single Store",
      controlID: "liSingleStore",
    },
  ],
};

export const quickbookRoutes = {
  name: "Quickbook",
  controlID: "liQuickbook",
  to: process.env.PUBLIC_URL + "/admin/quickbook",
  exact: true,
  icon: "money-check-dollar",
};

export const bulkExportRoutes = {
  name: "Bulk Export",
  controlID: "liBulkExport",
  to: process.env.PUBLIC_URL + "/admin/bulk-export",
  exact: true,
  icon: "cloud-arrow-down",
};

export const apiFieldRelationshipRoutes = {
  name: "API Field Relationship",
  controlID: "liAPIFieldRelationshipMap",
  to: process.env.PUBLIC_URL + "/admin/api-field-relationship",
  icon: "folder-tree",
  exact: true,
};
export const quickSearchRoutes = {
  name: "Quicksearch",
  controlID: "liQuickSearch",
  to: process.env.PUBLIC_URL + "/admin/quick-search",
  icon: "magnifying-glass",
  exact: true,
};
// export const spuDetails = {
//   name: "SPU Details",
//   controlID: "liSpuDetails",
//   to: process.env.PUBLIC_URL + "/admin/spudetails",
//   icon: "computer",
// };
export const spuRoutes = {
  name: "SPU",
  to: process.env.PUBLIC_URL + "/admin/spudashboard",
  icon: "computer",
  badge: {
    type: 'success',
    text: "New"
  },
  children: [
    {
      to: process.env.PUBLIC_URL + "/admin/spudashboard",
      name: "Dashboard",
      controlID:"liSPUdashboard",
      badge: {
        type: 'success',
        text: "New"
      },
    },
    {
      to: process.env.PUBLIC_URL + "/admin/support/customerhealthcheck",
      name: "Customer Health Check",
      controlID: "licustomerhealthcheck",
    },
    {
      to: process.env.PUBLIC_URL + "/admin/spudetails",
      name: "SPU Details",
      controlID: "liSpuDetails",
    }
  ],
};
export const visitTrackingRoutes = {
  name: "Visit Tracking",
  controlID: "liVisitTracking",
  to: process.env.PUBLIC_URL + "/admin/visit-tracking",
  icon: "chart-line",
  exact: true,
};
// export const askMe = {
//   name: "Ask Me..!",
//   controlID: "liAskMe",
//   to: `${process.env.PUBLIC_URL}/admin/Chatbox`,
//   icon: "rocketchat",
//   exact: true,
// };

export const ApisubscriptionRoutes = {
  name: "API Subscription",
  controlID: "liApiSubscriptionComponent",
  to: process.env.PUBLIC_URL + "/admin/api-subscription",
  icon: "dollar-sign",
  exact: true,
  badge: {
    type: 'success',
    text: sessionStorage.getItem("api_plan_update_counts") ? sessionStorage.getItem("api_plan_update_counts") : ""
  },
};

export default [
  dashboardRoutes,
  partnersRoutes,
  // analyticsRoutes,
  apiDiagnosticsRoutes,
  webhookRoutes,
  documentationRoutes,
  apiExplorerRoutes,
  errorCodesRoutes,ApisubscriptionRoutes,
  billingRoutes,
  settingsRoutes,
  supportRoutes,
  bulkExportRoutes,
  quickSearchRoutes,
  // quickbookRoutes,
  apiFieldRelationshipRoutes,
  //spuDetails,
  spuRoutes,
  visitTrackingRoutes,
  // askMe
];
